import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3ac79000&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=3ac79000&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac79000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac79000')) {
      api.createRecord('3ac79000', component.options)
    } else {
      api.reload('3ac79000', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=3ac79000&scoped=true&", function () {
      api.rerender('3ac79000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/activeXYFK/detail.vue"
export default component.exports